import { I18N } from "./I18N.js"
import { Stores } from './Stores.js'
import { Products } from './Products.js'
import { CartMini } from './CartMini.js'
import { Cart } from './Cart.js'
import { Order } from './Order.js'
import { Checkout } from './Checkout.js'
import { Confirmation } from './Confirmation.js'
import { Menu } from "./Menu.js"
import { AppContext } from "./AppContext.js"
import { AboutUs } from "./AboutUs.js"
import { Orders } from "./Orders.js"
import { CookieConsent } from "./CookieConsent.js"

class App {
	_target
	_appContext
	_stores
	_products
	_cartMini
	_cart
	_order
	_checkout

	constructor(targetId) {
		this._target = document.getElementById(targetId)
		this._target.innerHTML = `
			<div id="menu" class="card"></div>
			<div id="appShop" class="flexHorizontal">
				<div id="stores" class="card"></div>
				<div id="products" class="card"></div>
				<div id="cart" class="card"></div>
				<div id="order" class="card"></div>
				<div id="checkout" class="card"></div>
				<div id="confirmation" class="card"></div>
				<div id="aboutUs" class="card"></div>
				<div id="myorders" class="card"></div>
			</div>
			<div id="toaster"></div>
			<div id="storeOfflineDialog"></div>
		`
		I18N.translateElement(this._target)
	}

	init = () => {
		new CookieConsent()
		this._stores = new Stores('stores')
		this._aboutUs = new AboutUs('aboutUs')
		this._orders = new Orders('myorders')
		this._confirmation = new Confirmation('confirmation')
		this._checkout = new Checkout('checkout')
		this._order = new Order('order')
		this._order.addOnOrderUpdatedHandlers(this._checkout.setOrderVO)
		this._order.addOnRequirePrepaidHandlers(this._checkout.setPrepaidRequired)

		this._cart = new Cart('cart')
		this._cart.addOnCartUpdatedHandlers(this._order.setCartVO)
		this._products = new Products('products')
		this._products.addOnAddToCartHandlers(this._cart.addItemVO, this._order.addItemVO)
		// Cart content must be set to checkout before cart gets emptied
		this._checkout.addOnCheckoutDoneHandlers(() => this._confirmation.setCartVO(this._cart._cartVO), () => this._confirmation.setStore(this._cart._store), this._cart.empty, () => this._confirmation.setOrderVO(this._order._orderVO))
		this._stores.addOnStoreSelectedHandlers(this._products.setStore, this._order.setStore, this._cart.setStore)

		this._appContext = new AppContext()
		this._menu = new Menu('menu', this._appContext)
		this._appContext.setMenu(this._menu)
		this._appContext.setComponents('stores', [this._stores])
		this._appContext.setComponents('products', [this._products, this._cart])
		this._appContext.setComponents('aboutUs', [this._aboutUs])
		this._appContext.setComponents('myorders', [this._orders])
		this._orders.setAppContext(this._appContext)
		this._appContext.setComponents('cart', [this._cart, this._order, this._checkout])
		this._appContext.setComponents('confirmation', [this._confirmation])
		this._checkout.addOnProcessStartedHandlers(this._confirmation.setProcessInstanceId, this._appContext.setProcessInstanceId, () => this._confirmation.setLoadedByUrl(false))
		this._stores.setAppContext(this._appContext)
		this._cart.setAppContext(this._appContext)
		this._confirmation.setAppContext(this._appContext)
		this._confirmation.setStoresPromise(this._stores.getStoresPromise())
		this._confirmation.addOnNotAcceptedHandlers(this._cart.restore)
		this._checkout.setAppContext(this._appContext)
		this._order.setAppContext(this._appContext)

		this._cartMini = new CartMini('cart-mini') // Menu must exist
		this._cart.addOnCartUpdatedHandlers(this._cartMini.setCartVO)
		this._appContext.restore()
	}
}

export default App
